import Vue from "vue";
import VueI18n from "vue-i18n";
import th from "vee-validate/dist/locale/th.json";
import en from "vee-validate/dist/locale/en.json";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "th",
  messages: {
    th: {
      registration: "สมัครสมาชิก",
      register: "สมัคร",
      first_name: "ชื่อจริง",
      last_name: "นามสกุล",
      phone_number: "เบอร์โทรศัพท์",
      email: "อีเมล",
      success: "สำเร็จ",
      back: "กลับ",
      privacy_notice: "นโยบายความเป็นส่วนตัว",
      accept: "ยอมรับ",
      nationality: "สัญชาติ",
      passport_no: "หมายเลขพาสปอร์ต",
      rop_number: "เลข ROP",
      date_of_birth: "วัน เดือน ปีเกิด",
      date: "วัน",
      month: "เดือน",
      year: "ปี",
      welcome: "ยินดีต้อนรับ",
      intro_register: "กรุณากรอกข้อมูลสำหรับลงทะเบียน",
      registration_successfully: "ลงทะเบียนสำเร็จ",
      close: "ปิด",
      birthday: "วันเกิด",
      edit_profile: "แก้ไขข้อมูลส่วนตัว",
      save: "บันทึก",
      error_message_required: "กรุณากรอก",
      error_message_email: "ต้องเป็นรูปแบบอีเมล (ห้ามมีช่องว่าง)",
      error_message_alpha_num: "ต้องกรอกเป็นตัวอักษรภาษาอังกฤษและตัวเลข เท่านั้น",
      error_message_max: "ต้องมีความยาวไม่เกิน",
      error_message_phone: "เบอร์โทรศัพท์ ต้องเป็นรูปแบบเบอร์โทรศัพท์",
      error_message_regex: "รูปแบบไม่ถูกต้อง",
      characters: "ตัวอักษร",
      agree_policy: "อ่านและเข้าใจนโยบายความเป็นส่วนตัว",
      agree_consent_sensitive: "ข้าพเจ้าเข้าใจและทราบดีว่า ระบบมีการจัดเก็บข้อมูลทางการแพทย์และศาสนา เพื่อประมวลผลในการขอข้อมูลครั้งนี้",
      agree_information: "ยินดีรับข้อมูล ข่าวสาร และโปรโมชั่นจากการบินไทย",
      agree_consent_pdpa: "ตาม พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล 2562 บริษัทขอคำรับรองจากท่านว่า ท่านได้แจ้งให้ผู้โดยสารทราบถึง การคุ้มครองข้อมูลส่วนบุคคลและยินดีให้ข้อมูลส่วนบุคคลในการสำรองที่นั่ง",
      disagree: "เพิกถอนความยินยอม",
      disagree_consent_confirmation_1: "ท่านยืนยันที่จะเพิกถอนความยินยอม",
      disagree_consent_confirmation_2: "นโยบายความเป็นส่วนตัวหรือไม่",
      disagree_success_1: "เพิกถอนความยินยอม",
      disagree_success_2: "นโยบายความเป็นส่วนตัวเรียบร้อยแล้ว",
      confirm: "ยืนยัน",
      cancel: "ยกเลิก",
      ok: "ตกลง",
      checking: "กำลังตรวจสอบ",
      flight_time: "เวลาเที่ยวบิน",
      change_to: "เปลี่ยนเป็น",
      gate: "ประตูทางออก",
      terminal: "อาคารผู้โดยสาร",
      status: "สถานะ",
      flight_cancelled: "ยกเลิกเที่ยวบิน",
      prior_flight: "เที่ยวบินก่อนหน้า",
      next_flight: "เที่ยวบินถัดไป",
      contact_us: "ติดต่อเรา",
      hours: "ชั่วโมง",
      scheduled: "ตารางบิน",
      actual: "เวลาเดินทางจริง",
      baggage_carousel: "สายพานลำเลียงกระเป๋า",
      estimated: "เวลาที่คาดว่าจะมาถึง",
      update_success: "บันทึกสำเร็จ",
      edit_sensitive_consent: "แก้ไขความยินยอม",
      flight_cancelled_text_1: "เที่ยวบินยกเลิก",
      flight_cancelled_text_2: "ขออภัยในความไม่สะดวก",
      flight_cancelled_text_3: "ท่านผู้โดยสารสามารถระบุเที่ยวบินใหม่อีกครั้ง",
      validation: th.messages,
    },
    en: {
      registration: "Registration",
      register: "Register",
      first_name: "First name",
      last_name: "Last name",
      phone_number: "Phone number",
      email: "Email",
      success: "Success",
      back: "Back",
      privacy_notice: "Privacy notice",
      accept: "Accept",
      nationality: "Nationality",
      passport_no: "Passport No.",
      rop_number: "ROP Number",
      date_of_birth: "Date of birth",
      date: "Date",
      month: "Month",
      year: "Year",
      welcome: "Welcome",
      intro_register: "Please fill out the information to register.",
      registration_successfully: "Registration Successfully",
      close: "Close",
      birthday: "Birthday",
      edit_profile: "Edit profile",
      save: "Save",
      error_message_required: "Please fill the field",
      error_message_email: "must be email format (no space)",
      error_message_alpha_num: "must be alphabetic and number only",
      error_message_max: "must not exceed",
      error_message_phone: "Phone number must be phone number format",
      characters: "characters",
      agree_policy: "Agree policy notice",
      agree_consent_sensitive: "I understand and know that the company collect Medical, religious information for processing this request",
      agree_information: "Agree to receiving information news and promotion from Thai Airways",
      agree_consent_pdpa: "According to Thai Personal Data Protection Act 2019, Thai Airways International would like your comfirmation from you that the passengers has been informed of the data protection and agree to provide information for making reservation.",
      error_message_regex: "is invalid format",
      disagree: "Disagree",
      disagree_consent_confirmation_1: "Would you like to disagree",
      disagree_consent_confirmation_2: "with the privacy notice?",
      disagree_success_1: "You have successfully disagreed",
      disagree_success_2: "with the privacy notice.",
      confirm: "Confirm",
      cancel: "Cancel",
      ok: "OK",
      checking: "Checking",
      flight_time: "Flight time",
      change_to: "changed to",
      gate: "Gate",
      terminal: "Terminal",
      status: "Status",
      flight_cancelled: "Flight Cancelled",
      prior_flight: "Prior Flight",
      next_flight: "Next Flight",
      contact_us: "Contact Us",
      hours: "Hours",
      scheduled: "Scheduled",
      actual: "Actual",
      baggage_carousel: "Baggage Carousel",
      estimated: "Estimated",
      update_success: "Update successfully.",
      edit_sensitive_consent: "Edit consent",
      flight_cancelled_text_1: "Sorry for inconvenience",
      flight_cancelled_text_2: "But you can brownse",
      flight_cancelled_text_3: "your new flight now.  ",
      validation: en.messages,
    },
  },
});

export default i18n;
